import { TabGroup } from '@sanlam-glacier/app-common/components';
import StatementsForm from '../statements-form/StatementsForm';

const InvestmentInformationTabs = () => {
  return (
    <TabGroup
      tabs={[
        {
          content: <p>Portfolio summary</p>,
          label: 'Portfolio summary',
          name: 'PortfolioSummary',
          showOverflow: true
        },
        {
          content: <p>Investment summary</p>,
          label: 'Investment summary',
          name: 'InvestmentSummary',
          showOverflow: true
        },
        {
          content: <StatementsForm />,
          label: 'Statements',
          name: 'Statements',
          showOverflow: true
        },
        {
          content: <p>Annuity details</p>,
          label: 'Annuity details',
          name: 'AnnuityDetails',
          showOverflow: true
        },
        {
          content: <p>Effective annual cost</p>,
          label: 'Effective annual cost',
          name: 'EffectiveAnnualCost',
          showOverflow: true
        },
        {
          content: <p>Intermediary details</p>,
          label: 'Intermediary details',
          name: 'IntermediaryDetails',
          showOverflow: true
        }
      ]}
    />
  );
};

export default InvestmentInformationTabs;
